import { render, staticRenderFns } from "./SkuInfoTable.vue?vue&type=template&id=e4ebe49a&scoped=true&"
import script from "./SkuInfoTable.vue?vue&type=script&lang=js&"
export * from "./SkuInfoTable.vue?vue&type=script&lang=js&"
import style0 from "./SkuInfoTable.vue?vue&type=style&index=0&id=e4ebe49a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ebe49a",
  null
  
)

export default component.exports